import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type InterfaceRenameModalAction = "confirm" | "cancel";

export function useEmitInterfaceRenameModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: InterfaceRenameModalAction) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.InterfaceRenameModal,
        optionSelected,
      });
    },
    [accountId],
  );

  return { emit };
}
